import md5 from "js-md5";
import moment from "moment";

//签名
function getSign(report,signType){
    let strSign;
    let strReport=report.split("").sort().join("");
    switch (signType) {
        case "MD5":
          strSign=md5(strReport+md5("rv2020","utf-8"),"utf-8");
            break;
        case "RSA":
            break;
        case "3DES":
            break;
        default:
            strSign=md5(strReport+md5("rv2020"));
            break;
    }
    return strSign;
};

//创建报文头
function createCommonReport(traCode,data){
    var params = {
        traCode,
         version: "1",
         reqSeq: "sn"+ (moment().format("x")*1),
         sign: "",
         signType:"MD5"
    };
    if(data){
        params.data = data;
    }
    var encode = encodeURI(JSON.stringify(params));
    var sign = getSign(encode,"MD5");
    return Object.assign({},params,{
        sign
    });
};

export default createCommonReport;